import SRAPI from './apis/sportradar_api';

export default {
  sportradar: SRAPI
};
